export default __webpack_public_path__ + "static/media/goldPT.3807980c.png";